export default __webpack_public_path__ + "static/media/logo.26e40045.svg";